import { get, post } from '../../../../api/axios';
import { AuthEndpoints } from '../../../../api/endpoints/AuthEndpoints';
import { AccountEndpoints } from '../../../../api/endpoints/AccountEndpoints';
import { type AuthModel } from './_models';
import { type AccountDetailsDto } from '../../../models/AccountDetailsDto';

export function login(email: string, password: string) {
  return post<AuthModel>(AuthEndpoints.login, {
    username: email,
    password,
  });
}

export function loginWithGoogle(token: string) {
  return post<AuthModel>(AuthEndpoints.googleLogin, { token: token });
}

export function resetPassword(token: string, password: string) {
  return post<string>(AuthEndpoints.resetPassword, { token: token, password: password });
}

export function refreshToken(refreshToken: string) {
  return post<AuthModel>(AuthEndpoints.refreshToken, { refresh_token: refreshToken });
}

export const getUserPreferencesDetails = () => {
  return get<AccountDetailsDto>(AccountEndpoints.details);
};

export function forgotPassword(email: string) {
  return post<string>(AuthEndpoints.forgotPassword, { email: email });
}

export const logout = () => {
  return get<string>(AuthEndpoints.logout);
};
